/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceGroupInfoRespVo } from './AdditionalServiceGroupInfoRespVo';
import {
    AdditionalServiceGroupInfoRespVoFromJSON,
    AdditionalServiceGroupInfoRespVoFromJSONTyped,
    AdditionalServiceGroupInfoRespVoToJSON,
    AdditionalServiceGroupInfoRespVoToJSONTyped,
} from './AdditionalServiceGroupInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseAdditionalServiceGroupInfoRespVo
 */
export interface ResponseAdditionalServiceGroupInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdditionalServiceGroupInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdditionalServiceGroupInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {AdditionalServiceGroupInfoRespVo}
     * @memberof ResponseAdditionalServiceGroupInfoRespVo
     */
    data?: AdditionalServiceGroupInfoRespVo;
}

/**
 * Check if a given object implements the ResponseAdditionalServiceGroupInfoRespVo interface.
 */
export function instanceOfResponseAdditionalServiceGroupInfoRespVo(value: object): value is ResponseAdditionalServiceGroupInfoRespVo {
    return true;
}

export function ResponseAdditionalServiceGroupInfoRespVoFromJSON(json: any): ResponseAdditionalServiceGroupInfoRespVo {
    return ResponseAdditionalServiceGroupInfoRespVoFromJSONTyped(json, false);
}

export function ResponseAdditionalServiceGroupInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdditionalServiceGroupInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdditionalServiceGroupInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseAdditionalServiceGroupInfoRespVoToJSON(json: any): ResponseAdditionalServiceGroupInfoRespVo {
    return ResponseAdditionalServiceGroupInfoRespVoToJSONTyped(json, false);
}

export function ResponseAdditionalServiceGroupInfoRespVoToJSONTyped(value?: ResponseAdditionalServiceGroupInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdditionalServiceGroupInfoRespVoToJSON(value['data']),
    };
}

